import React from 'react'
import PropTypes from 'prop-types'

import { EMPTY_CLASS_LIST_MESSAGES, ITEM_KINDS } from '../constants'
import { DropdownItem, DropdownLink, SectionLabel } from '../component.styles'
import {
  Column,
  ColumnBody,
  ColumnFade,
  ColumnList,
  EmptyMessage,
} from './component.styles'

const DropdownColumn = ({
  column,
  columnId,
  isFadeVisible,
  listRef,
  onItemClick,
  onListScroll,
  scrollbarWidth,
}) => {
  const { items, kind, tier, title } = column
  const titleId = title ? `${columnId}-title` : undefined
  const isEmptyClassList = kind === ITEM_KINDS.classList && items?.length === 0

  return (
    <Column data-testid={columnId}>
      {title && <SectionLabel id={titleId}>{title}</SectionLabel>}
      <ColumnBody>
        {isEmptyClassList && (
          <EmptyMessage>{EMPTY_CLASS_LIST_MESSAGES[tier]}</EmptyMessage>
        )}
        {items?.length > 0 && (
          <ColumnList
            aria-labelledby={titleId}
            onScroll={onListScroll}
            ref={listRef}
          >
            {items.map((item, index) => (
              <DropdownItem key={`${item.title}-${item.route}`}>
                <DropdownLink
                  dataTestId={`${columnId}-link-${index}`}
                  href={item.route}
                  isActive={item.isSelected || false}
                  onClick={event => onItemClick(event, item.route)}
                  target="_self"
                >
                  {item.title}
                </DropdownLink>
              </DropdownItem>
            ))}
          </ColumnList>
        )}
        {isFadeVisible && (
          <ColumnFade
            aria-hidden="true"
            data-testid={`${columnId}-fade`}
            style={{ right: `${scrollbarWidth / 16}rem` }}
          />
        )}
      </ColumnBody>
    </Column>
  )
}

DropdownColumn.propTypes = {
  column: PropTypes.shape({
    kind: PropTypes.oneOf(Object.values(ITEM_KINDS)).isRequired,
    title: PropTypes.string,
    tier: PropTypes.number,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        route: PropTypes.string,
        isSelected: PropTypes.bool,
      }),
    ),
  }).isRequired,
  columnId: PropTypes.string.isRequired,
  isFadeVisible: PropTypes.bool,
  listRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  onItemClick: PropTypes.func.isRequired,
  onListScroll: PropTypes.func,
  scrollbarWidth: PropTypes.number,
}

export default DropdownColumn
